var _ = require('underscore');
var React = require("react");
const createReactClass = require("create-react-class");

var form = require('../../../deploynaut/js/Form.jsx');

const deployTriggers = {
	Submitted: 'Submitted',
	Approved: 'Approved',
	Rejected: 'Rejected',
	Invalidated: 'Invalidated',
	Started: 'Started',
	Successful: 'Successful',
	Failed: 'Failed'
};

var SlackForm = createReactClass({
	getInitialState: function() {
		var state = {
			id: null,
			name: null,
			team: null,
			deployTriggers: []
		};

		var integration = this.props.integration;
		if (integration && integration.options !== undefined) {
			state.id = integration.id;
			state.name = integration.options.Name;
			state.team = integration.options.Team;
			state.webhookURL = integration.options.IncomingWebhookURL;

			_.each(deployTriggers, function(value, index) {
				// CheckboxSet name and value needs to be the name, so we have to use the
				// display name for the key in our deployTriggers const
				var fullName = "Deploy" + index;
				if (integration.options[fullName]) {
					state.deployTriggers.push(index);
				}
			});
		}

		return state;
	},

	render() {
		var slackForm = null;
		if (this.state.id) {
			slackForm = (
				<form.Form
					ref={'slackForm'}
					url={this.props.model.UpdateURL}
					securityID={this.props.model.InitialSecurityID}
					buttonTitreduxle="Save"
					buttonSubmittingTitle="Saving"
					afterSuccess={this.props.afterSuccess}
				>
					<div className="form-group">
						<label htmlFor="Hooks">Send a message to <strong>{this.state.name}</strong> channel on these deployment events:</label>
						<form.CheckboxSet
							name="Hooks"
							source={deployTriggers}
							value={this.state.deployTriggers}
						/>
					</div>

					<form.Hidden name="Type" value="Slack" />
					<form.Hidden name="ID" value={this.state.id} />
				</form.Form>
			);
		} else {
			slackForm = (
				<form
					method="post"
					action="/naut/oauth/slack/authorize"
				>
					<p>Connect your Slack team below to send deployment notifications to a Slack channel.</p>
					<p>You'll be able to choose what deployment events to send a message for once you've connected your Slack team.</p>

					<button type="submit" className='btn-link'>
						<img
							alt="Add to Slack"
							height="40"
							width="139"
							src="https://platform.slack-edge.com/img/add_to_slack.png"
							srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x"
						/>
					</button>

					<input type="hidden" name="env" value={this.props.model.Environment} />
				</form>
			);

		}
		return (
			<div className="integration-form">
				{slackForm}
			</div>
		);
	}
});

module.exports = SlackForm;
